import { useEffect } from "react";
import { PropTypes } from "prop-types";

/**
 * @return {null}
 */
function ExpandedPolyline({
  positions,
  color,
  map,
  onClick,
  L,
  expandedRoutes
}) {
  useEffect(() => {
    let invisiblePolyline, whitePolyline, activePolyline, decorator;

    const draw = () => {
      invisiblePolyline = L.polyline(positions, {
        weight: 15,
        opacity: 0,
        pane: "overlayPane",
        smoothFactor: 2
      }).addTo(map.leafletElement);

      whitePolyline = L.polyline(positions, {
        color: "#fff",
        weight: 6,
        opacity: 1,
        pane: "overlayPane",
        smoothFactor: 2
      }).addTo(map.leafletElement);

      activePolyline = L.polyline(positions, {
        color,
        weight: 4,
        opacity: 0.8,
        pane: "overlayPane",
        smoothFactor: 2
      }).addTo(map.leafletElement);

      invisiblePolyline.on("click", onClick);

      whitePolyline.on("click", onClick);

      activePolyline.on("click", onClick);

      try {
        decorator = L.polylineDecorator(activePolyline, {
          patterns: [
            // defines a pattern of 8px arrows, repeated every 80px on the line
            {
              offset: 10,
              repeat: 80,
              symbol: L.Symbol.arrowHead({
                pixelSize: 8,
                pathOptions: {
                  pane: "overlayPane",
                  stroke: true,
                  weight: 3,
                  polygon: false,
                  color: color,
                  fill: color,
                  fillOpacity: 1,
                  opacity: 1,
                  pixelSize: 8
                }
              })
            }
          ]
        }).addTo(map.leafletElement);

        decorator.on("click", onClick);
      } catch (e) {
        console.log(e);
      }
    };

    const clear = () => {
      map.leafletElement.removeLayer(invisiblePolyline);
      map.leafletElement.removeLayer(whitePolyline);
      map.leafletElement.removeLayer(activePolyline);
      map.leafletElement.removeLayer(decorator);
    };

    draw();

    return () => {
      clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positions, expandedRoutes]);

  return null;
}

ExpandedPolyline.propTypes = {
  position: PropTypes.array,
  map: PropTypes.object
};

export default ExpandedPolyline;
